import { OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import * as _ from 'lodash';
import { CommonModule, DatePipe } from '@angular/common';
import { Component, ElementRef, ViewChild } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { selectCampaignList } from 'app/campaign/features/campaign.selectors';
import { CoreModule } from 'app/core/core.module';
import { selectOrgUser } from 'app/dashboard/features/dashboard.selectors';
import { SharedService } from 'app/virtual-event/services/shared.service';
import { Subject, first, takeUntil } from 'rxjs';
import * as DialogActions from 'app/dialog/features/dialog.actions';
import { Router } from '@angular/router';
import { PendingService } from 'app/reports/services/pending.service';
import { loadManageCampaignList, loadPendingCampaignList } from 'app/campaign/features/campaign.actions';
import { PartySignupPageService } from 'app/router-wrapper/services/party-signup-page/party-signup-page.service';
import { PartySignupPopoverComponent } from '../party-signup-popover/party-signup-popover.component';
import { PartySignupTabsService } from 'app/manage-party-signup/services/party-signup-tabs.service';
import { RouteReuseStrategyService } from 'app/router-wrapper/services/route-reuse-strategy-service/route-reuse-strategy-service.service';

@Component({
  selector: 'app-party-signup-details',
  standalone: true,
  imports: [CommonModule,CoreModule,PartySignupPopoverComponent],
  templateUrl: './party-signup-details.component.html',
  styleUrl: './party-signup-details.component.scss',
  providers:[DatePipe]
})
export class PartySignupDetailsComponent implements OnInit,OnDestroy{
  public selectedPartySignupId:string;
  public selectedTab;
  public campaignNotFound : boolean = false;
  public selectedPartySignup;
  public isDownloadHovered = false;
  public updatedOnProperty: Date;
  public nameProperty: string;

  public takeUntilRouteReuseStrategySubject: Subject<any> = new Subject();
  constructor(
    private element: ElementRef,
    public router: Router,
    private route:ActivatedRoute,
    public sharedService: SharedService,
    public partySignupPageService: PartySignupPageService,
    public pendingService: PendingService,
    private store: Store,
    private tabsService:PartySignupTabsService,
    private routeReuseStrategyService: RouteReuseStrategyService,
  )
  {}

  ngOnInit() {
    const $ = window['$'];

    this.routeReuseStrategyService.status = true;
    this.routeReuseStrategyService.routeReuseStrategySubject.pipe(
      takeUntil(this.takeUntilRouteReuseStrategySubject)
    ).subscribe(({ future }) => {
      switch(future.fragment) {
        case "":
          $(`#paidTabNav`).tab('show');
          break;
        default:
          $(`#${future.fragment}Nav`).tab('show');
      }
    });

    this.route.paramMap.subscribe(params => {
      this.selectedPartySignupId = params.get('id');
    });

    this.orgUser$.pipe(
      takeUntil(this.takeUntilSubject)
    ).subscribe((user: any) => {
      const { access } = user.loggedInUser ? user.loggedInUser: {
        access: [1]
      };
    });

    this.store.dispatch({
      type: loadManageCampaignList.type,
      payload: this.sharedService.token,
      campaignTypes:[5],
    });

    const styles = window['documentManager'].createElement('link');
    styles.href = 'paybee-spa/styles.css?v=398';
    styles.rel = 'stylesheet';
    window['$'](this.containerRef.nativeElement).append(styles);
  }

  ngOnDestroy(): void {
    this.takeUntilRouteReuseStrategySubject.next(null);
    this.takeUntilRouteReuseStrategySubject.complete();
  }

  
  public activeTab = 'paid';
  public campaigns$ = this.store.pipe(
      select(selectCampaignList)
  );

  public campaigns = [];
  public orgUser$ = this.store.pipe(
    select(selectOrgUser),
    first(user => !_.isNull(user)),
  );

  @ViewChild("container", { static: true }) containerRef: ElementRef;

  public takeUntilSubject: Subject<any> = new Subject();

  ngAfterViewInit(): void {
    let self = this;
    this.showPartySignupReport();
    $('a[role="tab"]').off('shown.bs.tab');
    $('a[role="tab"]').on('shown.bs.tab', ({ target }) => {
      switch(target.id) {
        case 'paidTabNav':
          window['orgMain'].showPartySignupDonations(self.partySignupPageService);
          break;
        case 'pendingsTabNav':
          self.getPartySignupPendingReport();
          break;
        case 'remindersTabNav':
          window['orgMain'].showPartySignupRemindersPage(self.partySignupPageService);
          break;
        case 'promoCodesTabNav':
          window['orgMain'].showPartySignupPromoCodes(self.partySignupPageService);
          break;
      }
    })

    $(this.element.nativeElement).off("click");
    $(this.element.nativeElement).on("click", "a[role='tab']", function(event) {
      event.preventDefault();

      const fragment = $(this).data('fragment');
      self.router.navigate([], { relativeTo: self.route, fragment });
    });
  }

  loadView(list){
    if(list){
      if(list.length){
          $('#partySignupReportNoCampaign').hide();
          $('#partySignupBidSheetDropdown').show();
          $('#partySignupReportCampaignBlock').show();
          $('#managePartySignupCampaignData').show();
          return true
          
      }else{
          $('#managePartySignupCampaignData').hide();
          $('#partySignupReportNoCampaign').show();
          $('#partySignupBidSheetDropdown').hide();
          $('#partySignupReportCampaignBlock').hide();
          return false
      }
    }
    return false
  }

  showPartySignupReport() {
    const self = this;
    const $ = window['$'];

    window['orgMain'].getPartySignupReport(this.selectedPartySignupId ?? null).then((list)=>{
      if(!this.loadView(list)){
        return
      }

      this.campaigns = [...list];
      this.selectedPartySignup = this.campaigns.find(item => item.id === this.selectedPartySignupId);
      this.updatedOnProperty = new Date(this.selectedPartySignup.updated * 1000);
      this.nameProperty = window['utils'].transformString(this.selectedPartySignup.name)
      self.partySignupPageService.campaign = this.selectedPartySignup;

      const tabNavigationService = window['tabNavigationService'];
      tabNavigationService.changeTab('party-signup',this.tabsService.selectedTab ?? 'paid')
      const activeTab = tabNavigationService.getActiveTab('party-signup');

      window['$']('.datepicker').pickadate({
        formatSubmit: 'yyyy/mm/dd',
        closeOnSelect: true,
        closeOnClear: false,
        selectYears: true,
        selectMonths: true
      });
      
      switch(activeTab.id) {
        case 'paid':
          tabNavigationService.unselectTab('party-signup', 'paid');
          tabNavigationService.unselectTab('party-signup', 'pendings');
          tabNavigationService.unselectTab('party-signup', 'reminders');
          tabNavigationService.unselectTab('party-signup', 'promoCodes');
          window['orgMain'].showPartySignupDonations(self.partySignupPageService);
          break;
        case 'pendings':
          tabNavigationService.unselectTab('party-signup', 'paid');
          tabNavigationService.unselectTab('party-signup', 'pendings');
          tabNavigationService.unselectTab('party-signup', 'reminders');
          tabNavigationService.unselectTab('party-signup', 'promoCodes');
          window['orgMain'].showCampaignPending({
            id: this.selectedPartySignupId,
            page: 'campaignPartySignupDonationsReport'
          }, this.selectedPartySignup);
          break;
        case 'reminders':
          tabNavigationService.unselectTab('party-signup', 'paid');
          tabNavigationService.unselectTab('party-signup', 'pendings');
          tabNavigationService.unselectTab('party-signup', 'reminders');
          tabNavigationService.unselectTab('party-signup', 'promoCodes');

          window['orgMain'].showPartySignupRemindersPage(self.partySignupPageService);
          break;
        case 'promoCodes':
          tabNavigationService.unselectTab('party-signup', 'paid');
          tabNavigationService.unselectTab('party-signup', 'pendings');
          tabNavigationService.unselectTab('party-signup', 'reminders');
          tabNavigationService.unselectTab('party-signup', 'promoCodes');
          window['orgMain'].showPartySignupPromoCodes(self.partySignupPageService);
          break;
      }
    });
  }

  getPartySignupPendingReport(){
    var id = this.selectedPartySignupId
    window['orgMain'].showCampaignPending({id,page:'campaignPartySignupDonationsReport'},this.selectedPartySignup);
  }

  onClickAddPending() {
    const action = DialogActions.openDialog({
      payload: {
        name: "AddPending",
        options: {
          size: 'small',
          modalClass:'modal--paybee modal-lg',
          containerClass:'mdb-modal-backdrop-paybee'
        },
        initialState: {
          campaignTypes: [5],
          selectedCampaign: this.selectedPartySignup,
          callback: (data) => {
            this.pendingService.addToCart(data).pipe(takeUntil(this.takeUntilSubject)).subscribe(() => {
              setTimeout(()=>{
                this.getPartySignupPendingReport();
              },400)
            });
          }
        }
      }
    });
    this.store.dispatch(action);
}
}
